import { ActionType, UnRegisterContractAction, UnRegisterState } from "./types";

const initialState: UnRegisterState = {
  sku: [],
  data: {
    invoicenumber: "",
    protectallSku: "",
    recordType: "",
    contractRetailPrice: "",
    totalProductRetailValue: "",
    customerId: "",
    customerFirstName: "",
    customerLastName: "",
    customerEmail: "",
    customerPrimaryTelephone: "",
    customerAlternativeTelephone: "",
    customerStreetAddress1: "",
    customerStreetAddress2: "",
    customerCity: "",
    customerState: "",
    customerPostalCode: "",
    customerCountryCode: "",
    customerDeliveryStreetAddress1: "",
    customerDeliveryStreetAddress2: "",
    customerDeliveryCity: "",
    customerDeliveryState: "",
    customerDeliveryPostalCode: "",
    customerDeliveryCountryCode: "",
    sellingStoreCode: "",
    sellingStoreLocation: "",
    sellingStoreAddress: "",
    sellingStoreCity: "",
    sellingStoreState: "",
    sellingStorePostalCode: "",
    sellingStoreCountryCode: "",
    contractPurchaseDate: null,
    deliveryDate: null,
    salesPersonId: "",
    referenceNumber: "",
    documents: [],
    productLineItems: [],
  },
};
export const UnRegisterReducer = (
  state: UnRegisterState = initialState,
  action: ActionType
) => {
  switch (action.type) {
    case UnRegisterContractAction.SET_SKUsOPTIONS: {
      return {
        ...state,
        sku: action.payload || [],
      };
    }

    case UnRegisterContractAction.SET_UPLOADED_DOCUMENTS: {
      return {
        ...state,
        data: {
          ...state.data,
          documents: state.data.documents.concat(action.payload || []),
        },
      };
    }

    case UnRegisterContractAction.CLEAN_UP: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
